module.exports = __webpack_public_path__ + "img/bust dart to bust dart.b0e479f7.png";